import React, { useState } from 'react';
import { Card, Button, Icon } from '../../../components/ui';

export interface ConfirmationRequest {
  type: 'confirmation_request';
  amount: number;
  currency: string;
  order_id: string;
  service_id?: string;
}

interface ChargeConfirmCardProps {
  request: ConfirmationRequest;
  onConfirm: (payload: string) => void;
  onCancel: (payload: string) => void;
  /** True while a chat turn is already in flight — disables both buttons. */
  disabled?: boolean;
}

const ChargeConfirmCard: React.FC<ChargeConfirmCardProps> = ({ request, onConfirm, onCancel, disabled }) => {
  const [clicked, setClicked] = useState<'confirm' | 'cancel' | null>(null);
  const isDisabled = disabled || clicked !== null;

  const handleCancel = () => {
    if (isDisabled) return;
    setClicked('cancel');
    onCancel(JSON.stringify({ type: 'charge_cancelled', order_id: request.order_id, accepted: false }));
  };

  const handleConfirm = () => {
    if (isDisabled) return;
    setClicked('confirm');
    onConfirm(
      JSON.stringify({
        type: 'charge_confirmed',
        order_id: request.order_id,
        service_id: request.service_id ?? '',
        amount: request.amount,
        accepted: true,
      })
    );
  };

  return (
    <Card pad style={{ maxWidth: 360, margin: '8px 0', border: '1px solid var(--warn)' }}>
      <style>{`
        @keyframes chargeConfirmSpin { to { transform: rotate(360deg); } }
        .charge-confirm-spin { display: inline-flex; animation: chargeConfirmSpin 0.7s linear infinite; }
      `}</style>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
        <Icon name="dollar" size={16} style={{ color: 'var(--warn)' }} />
        <strong>Confirm charge</strong>
      </div>
      <p className="muted" style={{ marginBottom: 16, fontSize: 14 }}>
        {request.amount.toFixed(2)} {request.currency} from your wallet?
      </p>
      <div style={{ display: 'flex', gap: 10 }}>
        <Button variant="ghost" style={{ flex: 1 }} disabled={isDisabled} onClick={handleCancel}>
          {clicked === 'cancel' ? <span className="charge-confirm-spin"><Icon name="refresh" size={13} /></span> : 'No, cancel'}
        </Button>
        <Button variant="primary" style={{ flex: 1 }} disabled={isDisabled} onClick={handleConfirm}>
          {clicked === 'confirm' ? <span className="charge-confirm-spin"><Icon name="refresh" size={13} /></span> : 'Yes, charge'}
        </Button>
      </div>
    </Card>
  );
};

export default ChargeConfirmCard;
